import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

interface ITextExportDialogProps {
    dialogName: string;
    hideDialog: () => void;
    periodNo?: number;
    exporting: boolean;
    message?: string;
    onConfirm: (filename: string, fileType: number) => void;
}

// Mirrors the real Oracle "Text" dialog (block TEXT) - Filename + Payroll Type (FILETYPE), OK/
// Cancel. TYPE and the Pick File button aren't on the real canvas (per the screenshot) so aren't
// reproduced here either. FILETYPE's 3 options match Text_Export_PayCor's own v_file_type
// comment: 0 = All, 1 = No Bonus/Commission, 2 = Commission Only. Unlike Oracle's own
// Download_AS_File (writes to a path on the user's machine), OK downloads through the browser the
// same way every other report/export on this page does - the Filename field just names that download.
const TextExportDialog = (props: ITextExportDialogProps) => {
    const { register, getValues } = useForm();

    // Dialog's own children unmount while closed (its CSSTransition uses unmountOnExit) and
    // remount fresh each time it's opened, so the default filename is computed inline here rather
    // than via a one-time useEffect+setValue - that would update a field that doesn't exist yet
    // while the dialog is closed, and never get picked up once it remounts.
    const defaultFilename = props.periodNo ? `PayrollExport_${props.periodNo}.csv` : 'PayrollExport.csv';

    const handleConfirm = () => {
        const values = getValues();
        props.onConfirm(values.filename || 'PayrollExport.csv', Number(values.fileType));
    };

    return (
        <Dialog title="Text Export File" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div className="form-row" style={{ alignItems: 'center', marginBottom: '.75rem' }}>
                <label style={{ width: '30%' }}>Filename</label>
                <RHFInputBox
                    name="filename"
                    type="text"
                    register={register}
                    defaultVal={defaultFilename}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '70%' }}
                />
            </div>
            <div className="form-row" style={{ alignItems: 'center', marginBottom: '.75rem' }}>
                <label style={{ width: '30%' }}>Payroll Type</label>
                <select name="fileType" ref={register} defaultValue="0" style={{ width: '70%', height: '3rem' }}>
                    <option value="0">All</option>
                    <option value="1">No Bonus/Commission</option>
                    <option value="2">Commission Only</option>
                </select>
            </div>
            {!!props.message && (
                <div style={{ color: 'red', textAlign: 'center', marginBottom: '.75rem' }}>{props.message}</div>
            )}
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: 'auto', marginRight: '1rem' }}
                    text={props.exporting ? 'Exporting...' : 'OK'}
                    disabled={props.exporting}
                    onClick={handleConfirm}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: 'auto' }}
                    text="Cancel"
                    disabled={props.exporting}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default TextExportDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/employeePayroll/TextExportDialog.tsx